import { inject, Injectable } from '@angular/core';
import { AuthService } from './core/auth/services/auth.service';
import { EnvironmentService } from './core/environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  private environmentService = inject(EnvironmentService);
  private authService = inject(AuthService);

  public async load(): Promise<any[]> {
    return Promise.all([
      this.environmentService.loadConfig(),
      this.authService.init(),
    ]);
  }
}
